import axios from 'axios';

export default {
  begin(exam_id, course_id) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/course/${course_id}/exam/${exam_id}/begin`)
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch(error => {
          reject(error.response.data);
        });
    });
  },

  answer(question_id, choice, exam_id, course_id) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/course/${course_id}/exam/${exam_id}/answer`, {
          question_id,
          choice
        })
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch(error => {
          reject(error.response.data);
        });
    });
  },

  complete(exam_id, course_id, answers) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/course/${course_id}/exam/${exam_id}/complete`, {
          choices: answers
        })
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch(error => {
          reject(error.response.data);
        });
    });
  }
};
